import Component from '../Component';

class EventDates extends Component {
  attachEventListeners() {
    const artistNames = [];
    const events = this.root.querySelectorAll('.event');

    events.forEach((event) => {
      const { artist } = event.dataset;
      if (artist !== undefined) {
        event.classList.add(artist);
        artistNames.push(artist);
      }
    });

    const multiShows = artistNames.reduce((acc, el, i, arr) => {
      if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
    }, []);

    multiShows.forEach((show) => {
      const artist = document.querySelectorAll(`.${show}`);
      const firstShow = artist[0];
      const lastShow = artist[artist.length - 1];

      artist.forEach((item) => {
        if (item !== firstShow) {
          item.classList.add('multiple_dates');
        }
      });

      let startDate = new Date(firstShow.dataset.date);
      startDate = startDate.toLocaleString('default', { month: 'short', year: 'numeric' });

      let endDate = new Date(lastShow.dataset.date);
      endDate = endDate.toLocaleString('default', { month: 'short', year: 'numeric' });

      const multiShowDate = firstShow.querySelector('.date');
      firstShow.querySelector('.location').innerHTML = 'Multiple Dates';

      const segment3 = firstShow.dataset.artist;
      const link = '/tickets/artist/' + segment3 + '/';
      firstShow.querySelector('.event_link').setAttribute('href', link);

      if (firstShow.querySelector('.white_cta')) {
        firstShow.querySelector('.white_cta').setAttribute('target', '_self');
        firstShow.querySelector('.white_cta').innerHTML = 'Tickets';
      }

      if (startDate !== endDate) {
        multiShowDate.innerHTML = `${startDate} - ${endDate}`;
      } else {
        multiShowDate.innerHTML = `${startDate}`;
      }
    });
  }

  componentDidMount() {
    this.attachEventListeners();
  }
}

export default EventDates;
